import React, { useState, useEffect, useCallback, useMemo } from "react";
import Navbar from "../../components/Navbar/Navbar";
import {
  AutoComplete,
  Breadcrumb,
  Button,
  Drawer,
  Modal,
  Select,
  Input,
} from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
  cashInOutReport,
  getCreditHistory,
  getPosOrderLines,
  posOrders,
} from "../../API  Functions/SessionHistoryFunctions";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment, { lang } from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import PosOrderTable from "../SessionHistory/PosOrdersTable";
import { AddBox } from "@mui/icons-material";
import { Plus } from "lucide-react";
import {
  getGroupProducts,
  getProductGroups,
} from "../../API  Functions/productGroupFunctions";
import ProductGroupTable from "./ProductGroupTable";
import NewGroup_Modal from "./NewGroupModal";
import { getInventoryallproducts } from "../../API  Functions/InventoryFunctions";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import dummy_image from "../../assets/Images/gallery.svg";
import deleteicon from "../../assets/Order/Delete.svg";

const ProductGroups = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const userData = useSelector((state) => state?.login?.user?.result);
  const [searchQuery, setSearchQuery] = useState("");
  const [Productoptions, setProductoptions] = useState([]);
  const [productList, setProductList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [englishName, setEnglishName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [isChange, setIsChange] = useState(false);
  const [groups, setGroups] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [Loading, setLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const [drawerData, setDrawerData] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  const [originalGroupProducts, setOriginalGroupProducts] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    // if (user_id) {
    console.log("AAFNAHFAFAFBAFBAa");

    GetGroups();
    // }
  }, [currentLimit, currentOffset]);

  const GetGroups = async (text = "") => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      search: text,
      company_id: company_id,
      user_id: user_id,
      offset: currentOffset,
      limit: currentLimit,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setGroups(res1?.result[0]?.product_groups);
      } else {
        setGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const debouncedSearch = debounce((value) => {
    GetGroups(value);
  }, 1000);

  const handleRowClick = async (order) => {
    setDrawerVisible(true);
    setDrawerLoading(true);
    setDrawerData(order);
    setEnglishName(order?.name);
    setArabicName(order?.name_ar);

    // console.log("vdfggv", order);

    try {
      const payload = {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        company_id: company_id,
        user_id: user_id,
        group_id: order.id,
      };
      const res = await getGroupProducts(payload);

      // console.log("resresresres---->", res);

      if (res?.result[0]?.status_code === 200) {
        setOrderLines(res?.result[0]?.product_list || []);
        setOriginalGroupProducts(res?.result[0]?.product_list || []);
      } else {
        setOrderLines([]);
        setOriginalGroupProducts([]);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setDrawerLoading(false);
    }
  };

  const onCancel = () => {
    handleRowClick(drawerData);

    setSelectedProduct(null);
    setEnglishName(drawerData?.name);
    setArabicName(drawerData?.name_ar);
    setProductoptions([]);
    setSearchQuery("");
  };

  const handleGroupSave = async ({
    englishName,
    arabicName,
    selectedProducts,
    group_id,
  }) => {
    try {
      setGroupLoading(true);

      const payload = {
        company_id: company_id,
        user_id: user_id,
        product_ids: selectedProducts,
        ...(group_id
          ? { group_id }
          : { name: englishName, name_ar: arabicName }),
      };

      console.log("API Payload:", payload);

      const res = await axiosInstance.post(URLS.CREATE_PRODUCT_GROUP, payload);
      const result = res?.data?.result?.[0];

      if (result?.status === "with same name product group available.") {
        toast.error(
          t("Group name already exists. Please choose a different name."),
        );
        return;
      }

      if (result?.status_code === 200) {
        toast.success(
          group_id
            ? t("Group updated successfully")
            : t("Group created successfully"),
        );

        GetGroups();
        setCreateOpen(false);
      } else {
        toast.error(result?.status || "Operation failed");
      }
    } catch (error) {
      console.error("Error saving group:", error);
      toast.error("Something went wrong while saving the group");
    } finally {
      setGroupLoading(false);
    }
  };

  const confirmDelete = (group) => {
    setSelectedGroup(group);
    setShowConfirmModal(true);
  };

  const handleGroupDelete = async (group) => {
    try {
      setLoading(true);

      // console.log("handleRemoveProducts", selectedGroupProducts);

      const payload = {
        company_id: company_id,
        user_id: user_id,
        group_id: group?.id,
        is_delete: true,
      };

      // console.log("API Payload:", payload);

      const res = await axiosInstance.post(URLS.EDIT_GROUP, payload);
      const result = res?.data?.result?.[0];

      if (result?.status_code === 200) {
        toast.success(t("Group removed successfully"));

        GetGroups();
        setShowConfirmModal(false);
      } else {
        toast.error(result?.status || "Failed to remove products from group");
      }
    } catch (error) {
      console.error("Error removing products:", error);
      toast.error("حدث خطأ أثناء إزالة المنتجات من المجموعة");
    } finally {
      setLoading(false);
    }
  };

  // const handleEditSave = async (updatedRow) => {
  //     try {
  //         setLoading(true);

  //         // console.log("updatedRowgroup---->", updatedRow);

  //         const payload = {
  //             company_id: company_id,
  //             user_id: user_id,
  //             group_id: updatedRow?.id,
  //             is_delete: false,
  //             name: updatedRow?.name,
  //             name_ar: updatedRow?.name_ar,
  //         };

  //         // console.log("API Payload:", payload);

  //         const res = await axiosInstance.post(URLS.EDIT_GROUP, payload);
  //         const result = res?.data?.result?.[0];

  //         if (result?.status_code === 200) {
  //             toast.success((t("Group updated successfully")));

  //             GetGroups()
  //             setShowConfirmModal(false);
  //         } else {
  //             toast.error(result?.status || "Failed to remove products from group");
  //         }
  //     } catch (error) {
  //         console.error("Error removing products:", error);
  //         toast.error("حدث خطأ أثناء إزالة المنتجات من المجموعة");
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const handleGroupUpdate = async () => {
    try {
      setLoading(true);

      // Extract only IDs from orderLines
      const addProductIds = orderLines.map((p) => p.prod_id);

      // Extract IDs from originalProducts
      const originalProductIds = originalGroupProducts.map((p) => p.prod_id);

      // Find products that were removed
      const removeProductIds = originalProductIds.filter(
        (prod_id) => !addProductIds.includes(prod_id),
      );

      const payload = {
        company_id: company_id,
        user_id: user_id,
        group_id: drawerData?.id,
        is_delete: false,
        name: englishName,
        name_ar: arabicName,
        add_product_ids: addProductIds, // [23432, 534, 232]
        remove_product_ids: removeProductIds, // removed ones
      };

      const res = await axiosInstance.post(URLS.EDIT_GROUP, payload);
      const result = res?.data?.result?.[0];

      if (result?.status_code === 200) {
        toast.success(t("Group updated successfully"));
        GetGroups();
        onCancel();
        onClose();
      } else {
        toast.error(result?.status || "Failed to update group");
      }
    } catch (error) {
      console.error("Error updating group:", error);
      toast.error("حدث خطأ أثناء تحديث المجموعة");
    } finally {
      setLoading(false);
    }
  };

  console.log("selectedPRidcts=====>", selectedProduct);

  const handleProductSelect = (value) => {
    const selectedProduct = Productoptions.find(
      (product) => product.product_name === value,
    );

    if (!selectedProduct) return;

    // 🚫 No barcode → open modal
    if (!selectedProduct.barcode) {
      setSelectedProduct(selectedProduct);
      setSelectedProductId(selectedProduct.quant_id);
      return;
    }

    // 🚫 Duplicate check
    const isDuplicate = orderLines.some(
      (product) => product.prod_id === selectedProduct.quant_id,
    );

    if (isDuplicate) {
      toast.error(`${selectedProduct.product_name} is already in the list.`);
      return;
    }

    // ✅ Map Productoptions → orderLines structure
    const mappedProduct = {
      barcode: selectedProduct.barcode,
      machine_barcode: selectedProduct.machine_barcode,
      weight: 0,
      prod_id: selectedProduct.quant_id,
      name:
        selectedProduct.product_name2 && selectedProduct.product_name2 != ""
          ? selectedProduct.product_name2
          : selectedProduct.product_name,
      sale_price:
        selectedProduct.discounted_price ?? selectedProduct.current_price,
      qty_available: selectedProduct.system_quantity,
      forecasted_qty: selectedProduct.system_quantity,
      image_url: selectedProduct.product_image_url,
      is_loose: false,
      uom: selectedProduct.uom,
      product_type: "sp",
      is_favorite: false,
      product_main_categ: selectedProduct.categ_id,
      discount_master_id: false,
      discount_qty: selectedProduct.prod_discount ?? 0,
      discount_type: false,
      product_selling_units: [],
      is_package: false,
    };

    // ✅ Add to order lines
    setOrderLines((prev) => [...prev, mappedProduct]);
  };

  const onClose = () => {
    setDrawerVisible(false);
    setOrderLines([]);
    setEnglishName("");
    setArabicName("");
    setProductoptions([]);
    setSearchQuery("");
  };

  const searchResult = useCallback(
    debounce(async (value) => {
      setSearching(true); // start loader
      try {
        let payload = {};
        const response = await getInventoryallproducts(
          user_id,
          company_id,
          false,
          false,
          value,
          10,
          0,
        );
        console.log("response==>", response);

        if (response?.result[0]?.response) {
          setProductoptions(response.result[0].response);
        } else {
          setProductoptions([]);
        }
      } catch (error) {
        console.error(error);
        setProductoptions([]);
      } finally {
        setSearching(false); // stop loader always
      }
    }, 1000),
    [],
  );

  const handleDeleteLine = (id) => {
    setOrderLines((prev) => prev.filter((line) => line.prod_id !== id));
  };

  const hasProductDifference = useMemo(() => {
    if (!orderLines || !originalGroupProducts) return false;

    if (orderLines.length !== originalGroupProducts.length) return true;

    const originalIds = originalGroupProducts.map((p) => p.id).sort();
    const currentIds = orderLines.map((p) => p.id).sort();

    return originalIds.some((id, index) => id !== currentIds[index]);
  }, [orderLines, originalGroupProducts]);

  // console.log("Order Lines Response:", orderLines);

  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <Navbar heading="Product Groups" />
        <div className="custom-scrollbar ms-1 mt-2 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
          <div className="font-extrabold mb-3"></div>

          <div className=" mt-3">
            <div className=" flex justify-between mt-3 me-8">
              <SearchBox
                // showBarcode={true}
                searchResult={(values) => debouncedSearch(values)}
                placeholder={t("Search Groups")}
              />
              {!userData?.is_sub_store && !userData?.is_warehouse && (
                <button
                  className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                  // onClick={() => setCreateOpen(true)}
                  onClick={() => {
                    if (checkPermission("/pos/orders", isGinne)) {
                      setCreateOpen(true);
                    }
                  }}
                >
                  <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />

                  <span>{t("Create Groups")}</span>
                </button>
              )}
            </div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <ProductGroupTable
                  additionalData={groups}
                  showEdit={!userData?.is_sub_store && !userData?.is_warehouse}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                    {
                      console.log("Pagination values:", values);
                    }
                  }}
                  onRowClick={handleRowClick}
                  onDelete={confirmDelete}
                  onEditLine={handleRowClick}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Drawer */}
      <Drawer
        title={
          drawerData
            ? `${t("Group Name")} - ${
                i18n.language === "ar"
                  ? drawerData?.name_ar || ""
                  : drawerData?.name || ""
              }`
            : ""
        }
        placement={i18n.language === "ar" ? "left" : "right"}
        width={
          typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 500
        }
        onClose={onClose}
        visible={drawerVisible}
        styles={{
          header: {
            color: "#1E3ABA", // Change this to your desired color
            fontWeight: "bold",
            fontSize: "20px",
          },
        }}
      >
        <div className=" text-sm font-medium mb-2 -mt-2">
          <p>
            <strong>{t("Created by")}:</strong> {drawerData?.created_by}
          </p>
        </div>

        {!userData?.is_sub_store && !userData?.is_warehouse && (
          <>
            {/* {((hasProductDifference) || isChange) && ( */}
            <div className="mb-2 flex flex-col justify-end gap-2 sm:flex-row sm:gap-4">
              <button
                disabled={!hasProductDifference && !isChange}
                onClick={onCancel}
                className={`disabled:opacity-50 px-8 py-2 font-semibold text-xs border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
              >
                {t("Cancel")}
              </button>
              <button
                disabled={!hasProductDifference && !isChange}
                onClick={handleGroupUpdate}
                className={` disabled:opacity-50 px-8 py-2 font-semibold text-xs border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
              >
                {t("Save")}
              </button>
            </div>
            {/* // )} */}
          </>
        )}
        {!userData?.is_sub_store && !userData?.is_warehouse && (
          <>
            <h3 className="text-sm font-semibold mb-2 text-gray-600">
              {t("Group Name")}
            </h3>
            <div className="mb-2 flex w-full flex-col justify-between gap-2 md:flex-row md:gap-0">
              <div className="w-full md:me-2 md:w-6/12">
                <label className="block text-xs mb-2 font-medium text-gray-600">
                  {t("English")}
                </label>
                <Input
                  placeholder={t("Enter English name")}
                  className="h-8 text-sm mb-2 w-full"
                  value={englishName}
                  onChange={(e) => {
                    const val = e.target.value.replace(
                      /[^\u0600-\u06FFa-zA-Z0-9\s]/g,
                      "",
                    ); // Allow Arabic letters, Latin letters, numbers, and spaces
                    setEnglishName(val.trimStart()); // Trims leading spaces
                    setIsChange(true);
                  }}
                  maxLength={20}
                />
              </div>
              <div className="w-full md:w-6/12">
                <label className="block text-xs mb-2 font-medium text-gray-600">
                  {t("Arabic")}
                </label>
                <Input
                  dir="rtl"
                  placeholder={t("اكتب الاسم هنا")}
                  value={arabicName}
                  className="h-8 text-sm mb-2 w-full"
                  onChange={(e) => {
                    const val = e.target.value.replace(
                      /[^\u0600-\u06FFa-zA-Z0-9\s]/g,
                      "",
                    ); // Allow Arabic letters, Latin letters, numbers, and spaces
                    setArabicName(val.trimStart()); // Trims leading spaces
                    setIsChange(true);
                  }}
                  maxLength={20}
                />
              </div>
            </div>
            <div className="mb-3">
              <AutoComplete
                value={searchQuery}
                style={{ width: "100%", height: "43px", outline: "none" }}
                open={showDropdown}
                onDropdownVisibleChange={(open) => setShowDropdown(open)}
                options={Productoptions.map((prod) => ({
                  value: prod.product_name,
                  label: (
                    <div className="flex justify-between items-center">
                      <span>
                        {prod.product_name2 && prod.product_name2 != ""
                          ? prod.product_name2
                          : prod.product_name}
                      </span>
                      {orderLines.some((p) => p.prod_id === prod.quant_id) && (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#16A34A"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      )}
                    </div>
                  ),
                  disabled: orderLines.some((p) => p.prod_id === prod.quant_id),
                }))}
                filterOption={false}
                onSearch={(val) => {
                  setSearchQuery(val);
                  if (val.length >= 2) {
                    searchResult(val);
                    setShowDropdown(true); // keep open while typing
                  } else {
                    setProductoptions([]);
                    setShowDropdown(false);
                  }
                }}
                onSelect={(val) => {
                  setTimeout(() => setShowDropdown(true), 0);

                  handleProductSelect(val);

                  // Delay a tick to reopen dropdown
                }}
              >
                <Input
                  placeholder={t("search_product")}
                  size="large"
                  style={{
                    borderColor: "#d9d9d9", // remove border
                    boxShadow: "none", // remove hover/focus glow
                  }}
                  suffix={
                    searchQuery ? (
                      <CloseOutlined
                        onClick={() => {
                          setShowDropdown(true); // keep dropdown open after clearing
                          setSearchQuery(false);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                />
              </AutoComplete>
            </div>
          </>
        )}

        {drawerLoading ? (
          <div className="space-y-4 p-4">
            {/* Header Skeleton */}
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

            {/* Summary Skeleton */}
            {/* <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
            </div> */}

            {/* Product Line Skeletons */}
            {[1, 2, 3].map((_, idx) => (
              <div
                key={idx}
                className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
              >
                <div className="w-10 h-10 bg-gray-200 rounded"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div className="h-4 bg-gray-200 rounded w-10"></div>
              </div>
            ))}
          </div>
        ) : // <LoadingSpinner />
        // <div>{t("Loading order details...")}</div>
        drawerData ? (
          <div className="space-y-4">
            {/* Order Summary */}
            <div className="space-y-1 text-sm font-medium">
              <p>
                <strong>{t("Number of Products :")}</strong>{" "}
                {orderLines?.length}
              </p>
            </div>

            {/* Product Lines */}
            <div>
              {orderLines.map((line) => (
                <div
                  key={line.id}
                  className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
                >
                  {/* Image */}
                  {line.image_url ? (
                    <img
                      src={
                        (line.image_url
                          ? line.image_url
                          : line.product_image_url) || "/placeholder.png"
                      }
                      alt=""
                      className="w-10 h-10 object-contain rounded"
                    />
                  ) : (
                    <img
                      src={dummy_image}
                      alt=""
                      className="w-10 h-10 object-contain rounded"
                    />
                  )}

                  {/* Middle content */}
                  <div className="flex flex-col flex-1 mx-2">
                    <p className="font-semibold text-sm leading-tight">
                      {line.name || line.product_name}
                    </p>
                    <p className="text-xs text-gray-600">{line.barcode}</p>
                  </div>

                  {/* Price */}
                  <p className="font-normal whitespace-nowrap text-right mr-3">
                    EGP{" "}
                    {line.sale_price
                      ? line.sale_price.toFixed(2)
                      : line.current_price}
                  </p>

                  {/* Delete button */}
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                    <img
                      src={deleteicon}
                      className="cursor-pointer h-4 w-4 mx-2"
                      alt="Delete"
                      onClick={() => handleDeleteLine(line.prod_id)}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>{t("no_product_found")}</p>
        )}
      </Drawer>

      {/* Confirmation Modal */}
      <Modal
        open={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        footer={null}
        centered
        closable={false}
      >
        <div className="text-center p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-800">
            {t("Are you sure you want to delete this group ?")}
          </h3>
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={() => setShowConfirmModal(false)}
              className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
            >
              {t("No")}
            </button>
            <button
              onClick={() => handleGroupDelete(selectedGroup)} // ✅ fixed line
              disabled={loading}
              className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
            >
              {loading ? t("Removing...") : t("Yes")}
            </button>
          </div>
        </div>
      </Modal>

      {createOpen && (
        <NewGroup_Modal
          open={createOpen}
          editData={editData}
          onClose={() => {
            setEditData(null);
            setCreateOpen(false);
          }}
          onSave={handleGroupSave}
          onUpdateGroup={handleGroupUpdate}
          groupLoading={groupLoading}
        />
      )}
    </>
  );
};

export default ProductGroups;
